import React from 'react';
import './KakaoMap.style.css';

const { kakao } = window;

const KakaoMap = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    width = 300,
    height = 217,
    name = 'JM COFFEE',
    address = '부산광역시 기장군 기장읍 대변3길 8',
    onChange,
    level = 3,
    isMarker = true,
    markerImage = '', // 마커 이미지 주소
    markerSize = [64, 69], // 마커 사이즈
    markerOffset = [27, 69], // 마커 이미지 옵션. 마커의 좌표와 일치시킬 이미지 안에서의 좌표 설정
  } = props;

  /* ===== Variable ===== */

  /* ===== State ===== */
  const mapRef = React.useRef(null);

  /* ===== Hooks ===== */
  /**
   * 지도 렌더링
   * --
   */
  React.useEffect(() => {
    if (!kakao) return;

    const geoCoder = new kakao.maps.services.Geocoder();

    geoCoder.addressSearch(address, (result, status) => {
      // 정상적으로 검색이 완료 됐으면
      if (status === kakao.maps.services.Status.OK) {
        const lat = parseFloat(result[0].y);
        const lng = parseFloat(result[0].x);
        const coords = new kakao.maps.LatLng(lat, lng);

        // 지도 옵션
        const options = {
          center: new kakao.maps.LatLng(lat, lng), // 지도 중심 좌표 Default: JM 본사
          level: level, // 지도 확대 레벨
        };
        // 지도 생성
        const map = new kakao.maps.Map(mapRef.current, options);

        if (isMarker) {
          // 다른 이미지로 마커 생성 시
          const markerImg = !markerImage
            ? null
            : new kakao.maps.MarkerImage(
                markerImage,
                new kakao.maps.Size(markerSize[0], markerSize[1]),
                {
                  offset: new kakao.maps.point(
                    markerOffset[0],
                    markerOffset[1]
                  ),
                }
              );

          // 결과값으로 받은 위치르 마커로 표시
          const marker = new kakao.maps.Marker({
            map: map,
            position: coords,
            ...(markerImg && markerImg),
          });

          // 인포 윈도우로 장소에 대한 설명 표시
          if (name) {
            const infoWindow = new kakao.maps.InfoWindow({
              content: `<div style="width:150px;text-align:center;padding:6px 0;">${name}</div>`,
            });
            infoWindow.open(map, marker);
          }
        }

        onChange && onChange(lat, lng);
      }
    });
    // eslint-disable-next-line
  }, [address, name]);

  /* ===== Function ===== */

  /* ===== Render ===== */
  return (
    <div className="map_container" style={{ width: width, height: height }}>
      <div
        ref={mapRef}
        id="kakao_map"
        style={{ width: '100%', height: '100%' }}
      ></div>
    </div>
  );
};

export default KakaoMap;
